// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__19yPo","title":"AfterFrontImage_title__2j6ik"};